import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MM13OpInstruction } from 'src/app/analysis/cr13/models/MM13OpInstruction';
import { Attachment } from 'src/app/analysis/models/attachment/Attachment';

@Injectable({
    providedIn: 'root'
})
export class SeraAttachmentsMapperService {
    constructor(private translateService: TranslateService) {}

    mapAttachmentToTableEntry(attachment: Attachment) {
        return {
            ...attachment,
            isUploading: false
        };
    }

    mapOpInstructionToTableEntry(opInstruction: MM13OpInstruction) {
        return {
            ...opInstruction,
            classification: this.translateService.instant(opInstruction.classification),
            attachment: opInstruction.attachment,
            isUploading: false
        };
    }
}
